import Icon from "@react-native-vector-icons/material-design-icons";
import theme from "assets/theme";
import moment from "moment";
import React, { useContext, useMemo, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import PressableContainer from "webComponentsFormElements/PressableContainer.component";
import { AuthContext } from "webContext/Auth.context";
import { OrganizationContext } from "webContext/Organization.context";

const classes = StyleSheet.create({
  cardBody: {
    fontSize: 12,
    color: theme.color.darkGrey,
    marginTop: 2,
    textAlign: "center",
  },
  deleteIcon: {
    color: theme.color.red,
    fontSize: 20,
  },
  deletePressable: {
    position: "absolute",
    width: 20,
    height: 18,
    right: 12,
    top: 2,
    zIndex: 1,
  },
});

export default function TeamCard(props) {
  const { team, size, onPress, onDelete } = props;

  const { organizationColor } = useContext(OrganizationContext);
  const { isMessagingManager } = useContext(AuthContext);
  const [hovered, setHovered] = useState(false);

  const stateClasses = useMemo(
    () =>
      StyleSheet.create({
        cardContainer: {
          flexDirection: "column",
          overflow: "hidden",
          borderWidth: 2,
          padding: 25,
          borderColor: organizationColor,
          boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.25)",
          borderRadius: 15,
          justifyContent: "space-evenly",
        },
        cardTitle: {
          fontSize: 18,
          fontWeight: theme.font.weight.semibold,
          color: organizationColor,
          textDecorationColor: organizationColor,
          textDecorationStyle: "solid",
          textDecorationThickness: 1,
          textAlign: "center",
          bottom: 5,
        },
      }),
    [organizationColor],
  );

  return (
    <View
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <PressableContainer style={stateClasses.cardContainer} onPress={onPress}>
        <View>
          <Text style={stateClasses.cardTitle}>{team.name}</Text>
          <Text style={classes.cardBody}>
            {size} {size > 1 ? "Members" : "Member"}
          </Text>
          <Text style={classes.cardBody}>
            Last updated:{" "}
            {moment(team.changeDatetime).format("MMM DD, YYYY hh:mm A")}
          </Text>
        </View>
      </PressableContainer>
      {hovered && !isMessagingManager && (
        <PressableContainer
          rootStyle={classes.deletePressable}
          onPress={onDelete}
        >
          {!team?._associations?.isDefault && (
            <Icon style={classes.deleteIcon} name="close" />
          )}
        </PressableContainer>
      )}
    </View>
  );
}
